// import debug from 'debug'

// const logger = debug('CXF-CANVAS')
// logger.log = console.log.bind(console)
// export const log = (...args: any[]) =>
//   logger('%c CXF-CANVAS ->', 'background: pink; color: #bada55, font-size:20px', ...args)

export const log = (...args: any[]): void => {
  console.debug('%c CXF-CANVAS ->', 'background: pink; color: #bada55, font-size:20px', ...args)
}

export const loadScript = (src: string) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    // script.type = 'text/javascript'
    script.type = 'module'
    script.async = false
    script.src = src
    script.onload = resolve
    script.onerror = reject
    document.body.appendChild(script)
  })

export const createLeadingEdgeThrottle = <T extends (...args: any[]) => void>(
  fn: T,
  delay: number,
): T => {
  let lastCall = 0
  return ((...args: Parameters<T>) => {
    const now = Date.now()
    if (now - lastCall >= delay) {
      lastCall = now
      fn(...args)
    }
  }) as T
}

type Offer = {
  id: string
  tier: number
  productIds: { googleplay?: string }
}

export const transformPaymentContractIdsToNativePriceEvent = (
  ids: string[],
): {
  category: string
  offers: Offer[]
  eventName: string
  eventType: string
} =>
  ids.reduce(
    (prev, cur, idx) => {
      prev.offers.push({
        id: cur,
        tier: 0,
        productIds: {
          googleplay: cur,
        },
      })
      return prev
    },
    {
      category: 'all',
      offers: [] as Offer[],
      eventName: 'lemonstand.nativePrice',
      eventType: 'bubble',
    },
  )
